import { SxProps, Theme } from '@mui/material';

export const podiumStyles = {
	wrapper: {
		position: 'relative',
		height: '450px',
	},
	positionWrapper: {
		position: 'absolute',
		bottom: '-10px',
		left: '50%',
		transform: 'translateX(-50%)',
	},
	starsEffect: {
		position: 'absolute',
		top: '0',
		left: '50%',
		transform: 'translateX(-50%)',
	},
	medalWrapper: {
		position: 'relative',
		width: '114px',
		height: '114px',
		zIndex: 3,
	},
	avatarImage: {
		position: 'absolute',
		top: '4px',
		left: '50%',
		transform: 'translateX(-50%)',
		width: '110px',
		height: '110px',
		zIndex: -1,
	},
	avatarImg: {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
		borderRadius: '50%',
	},
	communityName: {
		fontFamily: 'Integral CF',
		fontSize: '18px',
		lineHeight: '25px',
		fontWeight: 500,
		textAlign: 'center',
		color: 'white',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		marginBottom: '11px',
	},
	score: {
		fontFamily: 'Montserrat',
		fontSize: '15px',
		lineHeight: '21px',
		fontWeight: 600,
		textAlign: 'center',
		color: 'white',
		whiteSpace: 'nowrap',
	},
	prizeWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '12px',
		marginBottom: '11px',
	},
	prizeAmount: {
		fontFamily: 'Montserrat',
		fontSize: '16px',
		lineHeight: '22px',
		fontWeight: 700,
		color: 'white',
	},
	goodsWrapper: {
		display: 'flex',
		alignItems: 'center',
		gap: '11px',
		justifyContent: 'center',
		marginBottom: '7px',
		maxWidth: '257px',
		padding: '0 10px',
	},
	goodsText: {
		fontFamily: 'Montserrat',
		fontSize: '13px',
		lineHeight: '18px',
		fontWeight: 600,
		whiteSpace: 'nowrap',
		color: 'rgba(255, 255, 255, 0.7)',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	gradient: {
		position: 'absolute',
		bottom: '0',
		left: '0',
		right: '0',
		zIndex: 3,
		height: '80px',
		background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 1))',
	},
	silverWrapper: {
		position: 'absolute',
		top: '88px',
		left: '96.5px',
	},
	silverEffect: {
		position: 'absolute',
		top: '-40%',
		left: '50%',
		transform: 'translateX(-50%)',
		width: '350px',
		height: '350px',
	},
	silverNameWrapper: {
		position: 'absolute',
		top: '132px',
		left: '50%',
		transform: 'translateX(-50%)',
		zIndex: 3,
	},
	silverPodiumWrapper: {
		position: 'absolute',
		top: '230px',
		left: '0%',
		transform: 'translate(25px, 25px)',
	},
	goldWrapper: {
		position: 'absolute',
		top: '0',
		left: '50%',
		transform: 'translateX(-50%)',
		zIndex: 3,
	},
	goldGoodsWrapper: {
		display: 'flex',
		alignItems: 'center',
		gap: '12px',
		justifyContent: 'center',
		marginBottom: '7px',
		maxWidth: '278px',
		padding: '0 10px',
	},
	goldGoodsText: {
		fontFamily: 'Montserrat',
		fontSize: '14px',
		lineHeight: '20px',
		fontWeight: 600,
		whiteSpace: 'nowrap',
		color: 'rgba(255, 255, 255, 0.7)',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	goldAvatarImage: {
		position: 'absolute',
		top: '5px',
		left: '50%',
		transform: 'translateX(-50%)',
		width: '142px',
		height: '142px',
		zIndex: -1,
	},
	goldEffect: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		zIndex: -2,
		width: '400px',
		height: '315px',
	},
	goldNameWrapper: {
		position: 'absolute',
		top: '190px',
		left: '50%',
		transform: 'translateX(-50%)',
	},
	goldPodiumWrapper: {
		position: 'absolute',
		top: '230px',
		left: '50%',
		transform: 'translateX(-50%)',
		zIndex: 2,
	},
	goldMedalWrapper: {
		position: 'relative',
		width: '152px',
		height: '170px',
	},
	bronzeWrapper: {
		position: 'absolute',
		top: '100px',
		right: '96.5px',
	},
	bronzeEffect: {
		position: 'absolute',
		top: '-40%',
		left: '50%',
		transform: 'translateX(-50%)',
		width: '400px',
		height: '400px',
	},
	bronzeNameWrapper: {
		position: 'absolute',
		top: '132px',
		left: '50%',
		transform: 'translateX(-50%)',
		zIndex: 3,
	},
	bronzePodiumWrapper: {
		position: 'absolute',
		top: '230px',
		right: '0%',
		transform: 'translate(-25px, 40px)',
	},
};
